export default ({ adminSettings }) =>
  adminSettings.data?.enabled_applications?.some(({ key }) => key === 'tribe');
